/**
 * 华为应用商店 → 广告命名模板（CLAUDE.md §pages/<domain> 薄壳）。
 *
 * 镜像 pages/tencent/AdNameTemplatePage.tsx；编辑器主体见
 * components/adNameTemplate/AdNameTemplateEditor.tsx（跨平台共享）。
 * 与腾讯页的差异：
 *   - 华为 API 服务（/api/v1/huawei/ad-name-template）与华为权限 key；
 *   - 空白模板不带任何默认字段（腾讯的默认枚举是腾讯代理名，不适用华为）；
 *   - 无「3 项组合」红线特例提示（该提示绑定腾讯 redline 消费逻辑，华为无此消费者）。
 *   - 每个字段仅 1 组枚举：allowSecondCombo=false，不展示「添加第 2 组枚举」。
 */

import { AdNameTemplateEditor } from "../../components/adNameTemplate/AdNameTemplateEditor";
import {
  getLatestTemplate,
  saveTemplate,
} from "../../services/huawei/adNameTemplate";
import { newEmptyTemplate } from "../../utils/adNameTemplateFactory";
import { PAGE_KEYS } from "../../config/permissions";

export default function AdNameTemplatePage() {
  return (
    <AdNameTemplateEditor
      pageKey={PAGE_KEYS.HUAWEI_AD_NAME_TEMPLATE}
      fetchLatest={getLatestTemplate}
      save={saveTemplate}
      createBlankTemplate={newEmptyTemplate}
      allowSecondCombo={false}
    />
  );
}
